/* eslint-disable */ 
import React from "react";
import { flatten } from "../utility";
import "../styles/pivot.css";

// const Columns = ["TerritoryID", "Type"];
// const Rows = ["Studio", "Title"];
// const Data = ["Count", "Price"]; // count('Id') as Count
// // const DataHeader = undefined;
// const DataHeader = ["Adet", "Fiyat"];
// const Aggregate = ["count", "sum"];

// -------- SQL -------
// SELECT Studio, Title, TerritoryID, Type, count(ID) as Count
// FROM react_pivot_imdb
// WHERE ...
// HAVING ...
// GROUP BY Studio, Title, TerritoryID, Type
// const Headers = ["Studio", "Title", "TerritoryID", "Type", "Count", "Price"];
// const Table = [
//   ["Fox", "1:00 P.M. - 2:00 P.M.", "GB", "TV Episode", 7, 150000],
//   ["Fox", "1:00 P.M. - 2:00 P.M.", "JP", "TV Episode", 8, 170000],
//   ["Fox", "1:00 P.M. - 2:00 P.M.", "US", "TV Episode", 9, 190000],
//   ["Fox", "Best Laid Plans", "GB", "Movie", 18, 250000],
//   ["Fox", "Best Laid Plans", "GB", "TV Episode", 23, 270000],
//   ["Fox", "Best Laid Plans", "JP", "TV Episode", 2, 290000],
//   ["Fox", "Best Laid Plans", "US", "Movie", 18, 30000],
//   ["Fox", "Best Laid Plans", "US", "TV Episode", 24, 150000],
//   ["Fox", "Homecoming", "GB", "TV Episode", 28, 10000],
//   ["Fox", "Homecoming", "JP", "TV Episode", 4, 1230000],
//   ["Fox", "Homecoming", "US", "TV Episode", 58, 1545000],
//   ["Fox", "Titanic", "GB", "Movie", 16, 153000],
//   ["Fox", "Titanic", "JP", "Movie", 4, 150000],
//   ["Fox", "Titanic", "US", "Movie", 8, 152000],
//   ["Paramount", "Homecoming", "GB", "Movie", 4, 10000],
//   ["Paramount", "Homecoming", "US", "Movie", 16, 50000],
//   ["Paramount", "Titanic", "GB", "Movie", 8, 152200],
//   ["Paramount", "Titanic", "JP", "Movie", 4, 100],
//   ["Paramount", "Titanic", "US", "Movie", 16, 153000],
//   ["Sony", "Best Laid Plans", "GB", "Movie", 13, 70000],
//   ["Sony", "Best Laid Plans", "GB", "TV Episode", 3, 15500],
//   ["Sony", "Best Laid Plans", "US", "TV Episode", 10, 4000],
//   ["Sony", "Homecoming", "GB", "TV Episode", 9, 1000],
//   ["Sony", "Homecoming", "US", "TV Episode", 10, 700]
// ];

const leafCount = (Data, node) => {
  if (node.children.length === 0) {
    return Data.length;
  } else {
    return node.children.reduce((acc, b) => acc + leafCount(Data, b), 0);
  }
};

const nodesAtDepth = (node, rdepth, cdepth = 0) => {
  if (cdepth === rdepth) {
    return [node];
  } else {
    return flatten(
      node.children.map(node => nodesAtDepth(node, rdepth, cdepth + 1))
    );
  }
};

const treeDepth = node => {
  if (node.children.length === 0) {
    return 0;
  } else {
    return 1 + Math.max(...node.children.map(treeDepth));
  }
};

const nodesOrderedByDepth = node => {
  let nodes = [];
  for (var depth = 0; depth <= treeDepth(node); depth++) {
    nodes.push(nodesAtDepth(node, depth));
  }
  return nodes;
};

const preorderedDFS = ({ node, branch = [] }) => {
  branch = branch.concat([node.value]);
  if (node.children.length === 0) {
    return [{ node, branch }];
  } else {
    return flatten([
      { node, branch },
      node.children.map(child => preorderedDFS({ node: child, branch }))
    ]);
  }
};

// Her children kümesi için sadece onların olduğu rowlar alıncak, orada yeni bir set oluşturlacak
// aynı zamanda yeni rowslar onların childları için...
const getChildren = (columns, Headers, rows) => {
  if (columns.length === 0) return [];
  const [headColumn, ...tailColumns] = columns;
  let id = Headers.indexOf(headColumn);
  let childrenMap = new Map();
  rows.forEach(row => {
    if (childrenMap.has(row[id])) {
      childrenMap.get(row[id]).push(row);
    } else {
      childrenMap.set(row[id], [row]);
    }
  });
  let children = [...childrenMap].map(([childvalue, childRows]) => {
    return {
      value: childvalue,
      children: getChildren(tailColumns, Headers, childRows)
    };
  });
  // console.log(
  //   "columns: ",
  //   columns,
  //   "childrenMap: ",
  //   childrenMap,
  //   "children",
  //   children
  // );
  return children ? children : [];
};

// const getColumnsTree = (Columns, Headers, Table) => {
//   let children = getChildren(Columns, Headers, Table);
//   return { value: Columns.join(" / "), children };
// };

// const getRowsTree = (Rows, Headers, Table) => {
//   let children = getChildren(Rows, Headers, Table);
//   return { value: Rows.join(" / "), children };
// };

// const columnsTree = {
//   value: "TerritoryID / Type",
//   children: [
//     {
//       value: "GB",
//       children: [
//         { value: "TV Episode", children: [] },
//         { value: "Movie", children: [] }
//       ]
//     },
//     {
//       value: "JP",
//       children: [
//         { value: "TV Episode", children: [] },
//         { value: "Movie", children: [] }
//       ]
//     },
//     {
//       value: "US",
//       children: [
//         { value: "TV Episode", children: [] },
//         { value: "Movie", children: [] }
//       ]
//     }
//   ]
// };

// const rowsTree = {
//   value: "Studio / Title",
//   children: [
//     {
//       value: "Fox",
//       children: [
//         { value: "1:00 P.M. - 2:00 P.M.", children: [] },
//         { value: "Best Laid Plans", children: [] },
//         { value: "Homecoming", children: [] },
//         { value: "Titanic", children: [] }
//       ]
//     },
//     {
//       value: "Paramount",
//       children: [
//         { value: "Homecoming", children: [] },
//         { value: "Titanic", children: [] }
//       ]
//     },
//     {
//       value: "Sony",
//       children: [
//         { value: "Best Laid Plans", children: [] },
//         { value: "Homecoming", children: [] }
//       ]
//     }
//   ]
// };
// Eğer ağaçta leaf değilsen, en altta değilsen sağ ve solunu çiz..
export const Pivot = props => {
  const report = props.Session.RX_Report.withId(props.id);
  const Table = report.data.rows;
  const Headers = report.data.fields.map(field => field.name);
  const Columns = report.config.columns;
  const Rows = report.config.rows;
  const Data = report.config.data;
  const DataHeader = report.config.header;
  const Aggregate = report.config.aggregate;
  const RowHeader = report.config.rowheader;
  const ColumnHeader = report.config.columnheader;
  let innerProps = {
    Table,
    Headers,
    Columns,
    Rows,
    Data,
    DataHeader,
    Aggregate,
    RowHeader,
    ColumnHeader
  };
  return <InnerPivot {...innerProps} />;
};

export const InnerPivot = props => {
  let {
    Table,
    Headers,
    Columns,
    Rows,
    Data,
    DataHeader,
    Aggregate,
    RowHeader,
    ColumnHeader
  } = props;
  const columnsTree = {
    value: ColumnHeader,
    children: getChildren(Columns, Headers, Table)
  };
  const rowsTree = {
    value: RowHeader,
    children: getChildren(Rows, Headers, Table)
  };

  let columnBranches = preorderedDFS({ node: columnsTree });
  let rowBranches = preorderedDFS({ node: rowsTree });
  let headersByDepth = nodesOrderedByDepth(columnsTree);
  let rowSpanOnHeaders = key => (
    <th
      colSpan={treeDepth(rowsTree) + 1}
      key={"thead_tr_indent_" + key}
      style={{ borderRight: key ? "1px solid #ddd" : 0 }}
    />
  );
  return (
    <div className="container">
      <div className="pivot">
        <div className="reactPivot">
          <div className="reactPivot-results">
            <table>
              <thead>
                {headersByDepth.map((nodesAtDepth, idx) => (
                  <tr key={"thead_tr_" + idx}>
                    {rowSpanOnHeaders(idx)}
                    {nodesAtDepth.map((node, id) => (
                      <th
                        style={{ borderRight: idx ? "1px solid #ddd" : 0 }}
                        colSpan={leafCount(Data, node)}
                        key={"thead_tr_" + idx + "_th_" + id}
                      >
                        {node.value}
                      </th>
                    ))}
                  </tr>
                ))}

                {DataHeader &&
                  DataHeader.length && (
                    <tr key={"thead_data_labels"}>
                      {rowSpanOnHeaders("data_labels")}
                      {headersByDepth[headersByDepth.length - 1].map(
                        (node, id) =>
                          DataHeader.map((header, idx) => (
                            <th
                              style={{
                                borderRight: idx ? "1px solid #ddd" : 0
                              }}
                              key={`thead_data_labels_th_${id}_th_${idx}`}
                            >
                              {header}
                            </th>
                          ))
                      )}
                    </tr>
                  )}
              </thead>
              <tbody>
                {rowBranches.map(({ node, branch }, idx) => (
                  <tr key={"tbody_tr_" + idx}>
                    {indentRow(
                      "tbody_tr_" + idx + "_td_indent_before_",
                      treeDepth(rowsTree) - treeDepth(node)
                    )}
                    <td
                      key={"tbody_tr_" + idx + "_td_" + 0}
                      title={"col.title"}
                      colSpan={treeDepth(node) + 1}
                    >
                      <span>{node.value}</span>
                    </td>
                    {dataRow(
                      Data,
                      Table,
                      Columns,
                      Rows,
                      Headers,
                      Aggregate,
                      branch,
                      columnBranches,
                      node
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const indentRow = (key, height) => {
  return [...Array(height).keys()].map(id => (
    <td key={key + id} className="reactPivot-indent" />
  ));
};
// {
//   Table.filter(row => row=>)
// }

const dataRow = (
  Data,
  Table,
  Columns,
  Rows,
  Headers,
  Aggregate,
  rowBranch,
  columnBranches,
  node
) => {
  // return Data.map( )
  // Columns, Rows, Data, Table, Headers
  // let rowTitleIndexes = Rows.map(rowTitle => Headers.indexOf(rowTitle));
  rowBranch = rowBranch.slice(1); //Remove Row Header
  // console.log("Column Branches Before:", columnBranches);
  columnBranches = columnBranches
    .map(({ node, branch }) => branch.slice(1))
    .filter(branch => branch.length === Columns.length); //Remove Column Header and do not tage aggregate values
  // console.log("Column Branches After:", columnBranches);
  let list = columnBranches.map(columnBranch => {
    // let dataBranch = rowBranch.concat(columnBranch);
    // console.log("rowBranch:", rowBranch, "columnBranch: ", columnBranch);
    let rows = Table.filter(
      row =>
        rowBranch.filter((item, id) => row[Headers.indexOf(Rows[id])] !== item)
          .length === 0
    ).filter(
      row =>
        columnBranch.filter(
          (item, id) => row[Headers.indexOf(Columns[id])] !== item
        ).length === 0
    );
    // console.log("Rows:", rows);
    if (rows.length === 1) {
      return Data.map((datum, id) => (
        <td key={datum + "_" + id}>{rows[0][Headers.indexOf(datum)]}</td>
      ));
    } else if (rows.length > 0) {
      return Data.map((datum, id) => (
        <td key={datum + "_" + id}>
          {aggregate(
            Aggregate[id],
            rows.map(row => row[Headers.indexOf(datum)])
          )}
        </td>
      ));
    } else
      return Data.map((datum, id) => <td key={datum + "_" + id}> {""}</td>);
  });
  // let rows = Table.filter(
  //   tableRow =>
  //     rowBranch.filter(
  //       (item, id) => tableRow[Headers.indexOf(Rows[id])] !== item
  //     ).length === 0
  // );
  // console.log("list", list);
  return list;
  // return Data.map((datum, id) => (
  //   <td key={datum + "_" + id}> {rows[0][Headers.indexOf(datum)]}</td>
  // ));
};

export const aggregate = (type, values) => {
  let result = undefined;
  let sum = values => values.reduce((agg, a) => (a ? agg + a : agg), 0);
  let median = values => {
    let arr = values.slice(0);
    arr.sort((a, b) => a - b);
    let lowMiddle = Math.floor((arr.length - 1) / 2);
    let highMiddle = Math.ceil((arr.length - 1) / 2);
    return (arr[lowMiddle] + arr[highMiddle]) / 2;
  };
  switch (type) {
    case "sum":
      result = sum(values);
      break;
    case "max":
      result = Math.max(...values);
      break;
    case "min":
      result = Math.min(...values);
      break;
    case "median":
      result = median(values);
      break;
    case "count":
      result = sum(values);
      break;
    case "average":
      result = sum(values) / values.length;
      break;
    default:
      result = undefined;
  }
  return result;
};

// Sum, average, median, count,
// , minimum, maximum

// Algoritma
// Data Columns ve Data Rows arrayi oluştur,
// Data Columns arrayden Header kısmını ortaya çıkart
// Data Rows arrayi kullanarak rowların dizilimini çıkaracağız...
// Data Columns a göre sıralama yapabilmeliyiz, toplam, max, min median alabilmeliyiz, aggragate tipi sorguda istenen gibi olacak...
// Çok temel bir tablo üzerinde test edip sonuçları gözlemleyelim..
// Dashboard, Chartlar, Alert flow diagramları, Arayüzler çıktıktan sonra bakabiliriz...
// Header row'u olacak,

//

// Birkaç örnek ekran,
// Tasarım modülü,
// Deployment süreci,



// WEBPACK FOOTER //
// ./src/components/data.js